function getAccordionPanel(item) {
    return item.querySelector('[data-accordion-item-content]');
  }
  
  function openAccordionItem(item, trigger, panel) {
    item.classList.remove('is-collapsed');
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    panel.style.overflow = 'hidden';
    panel.style.height = `${panel.scrollHeight}px`;
  
    const onEnd = (event) => {
      if (event.target !== panel || event.propertyName !== 'height') return;
      panel.style.height = '';
      panel.style.overflow = '';
      panel.removeEventListener('transitionend', onEnd);
    };
  
    panel.addEventListener('transitionend', onEnd);
  }
  
  function closeAccordionItem(item, trigger, panel, animate = true) {
    item.classList.add('is-collapsed');
    trigger.setAttribute('aria-expanded', 'false');
  
    if (!animate) {
      panel.style.overflow = 'hidden';
      panel.style.height = '0px';
      panel.hidden = true;
      return;
    }
  
    panel.style.overflow = 'hidden';
    panel.style.height = `${panel.scrollHeight}px`;
    panel.getBoundingClientRect();
  
    requestAnimationFrame(() => {
      panel.style.height = '0px';
    });
  
    const onEnd = (event) => {
      if (event.target !== panel || event.propertyName !== 'height') return;
      panel.hidden = true;
      panel.removeEventListener('transitionend', onEnd);
    };
  
    panel.addEventListener('transitionend', onEnd);
  }
  
  function toggleAccordionItem(item, trigger, panel) {
    if (item.classList.contains('is-collapsed')) {
      openAccordionItem(item, trigger, panel);
    } else {
      closeAccordionItem(item, trigger, panel);
    }
  }
  
  function initAccordionRoot(root) {
    if (root.dataset.accordionInitialized === 'true') return;
    root.dataset.accordionInitialized = 'true';
  
    root.querySelectorAll('[data-accordion-item]').forEach((item) => {
      const trigger = item.querySelector('[data-accordion-item-title]');
      const panel = getAccordionPanel(item);
      if (!trigger || !panel) return;
      closeAccordionItem(item, trigger, panel, false);
    });
  }
  
  export function initZone3Accordion() {
    document.querySelectorAll('.zone3__accordion').forEach(initAccordionRoot);
  
    if (document.documentElement.dataset.zone3AccordionBound === 'true') {
      return Promise.resolve(true);
    }
  
    document.documentElement.dataset.zone3AccordionBound = 'true';
  
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-accordion-item-title]');
      if (!trigger) return;
  
      const item = trigger.closest('[data-accordion-item]');
      if (!item?.closest('.zone3__accordion')) return;
  
      const panel = getAccordionPanel(item);
      if (!panel) return;
  
      toggleAccordionItem(item, trigger, panel);
    });
  
    return Promise.resolve(true);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZone3Accordion);
  } else {
    initZone3Accordion();
  }